import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from '../../common';
import { BUSINESS_RESOURCE_ENDPOINT } from '../endpoints';

export const endpoints = {
  Business: {
    Content: {
      BusinessLibrary: BUSINESS_RESOURCE_ENDPOINT('publisher/content'),
      NonCpd: BUSINESS_RESOURCE_ENDPOINT('publisher/non-cpd-content')
    }
  }
}

export const actions = createActions({
  BUSINESS: {
    CONTENT: {
      API: {
        GET: apiResourceActionCreator('contentResult'),
        GET_NON_CPD_CONTENT: apiResourceActionCreator('content'),
        GET_BY_ID: apiResourceActionCreator('content'),
        ADD_CONTENT: apiResourceActionCreator('content'),
        UPDATE_CONTENT: apiResourceActionCreator('content'),
        ARCHIVE_CONTENT: apiResourceActionCreator('content'),
        LOAD_MORE: apiResourceActionCreator('contentResult'),
        ADD_QUESTION: apiResourceActionCreator('question'),
        UPDATE_QUESTION: apiResourceActionCreator('question'),
        DELETE_QUESTION: apiResourceActionCreator('deleted'),
        GET_CONTENT_QUESTIONS: apiResourceActionCreator('questions'),
        DELETE_CONTENT: apiResourceActionCreator('deletedId'),
        GET_CONTENT_PASSED_USER_EMAILS: apiResourceActionCreator('passedUserEmails')
      },
      GET: (businessId, skip, query) => ({ businessId, skip, query }),
      GET_NON_CPD_CONTENT: (businessId) => ({ businessId }),
      GET_BY_ID: (businessId, contentId) => ({ businessId, contentId }),
      RESET_SELECTED_CONTENT: (businessId) => ({ businessId }),
      SAVE_CONTENT: (businessId, content, nextRoute) => ({ businessId, content, nextRoute }),
      ARCHIVE_CONTENT: (businessId, contentId) => ({ businessId, contentId }),
      LOAD_MORE: (businessId, skip, query) => ({ businessId, skip, query }),
      SAVE_QUESTION: (businessId, questionData) => ({ businessId, questionData }),
      DELETE_QUESTION: (businessId, contentId, questionId) => ({ businessId, contentId, questionId }),
      GET_CONTENT_QUESTIONS: (businessId, contentId) => ({ businessId, contentId }),
      DELETE_CONTENT: (businessId, contentId, contentQuery) => ({ businessId, contentId, contentQuery }),
      GET_CONTENT_PASSED_USER_EMAILS: (businessId, contentId) => ({ businessId, contentId })
    }
  }
})

export const apiActions = {
  business: {
    content: {
      get: (authToken, businessId, skip, query) => commonApiActions.authenticated.get(`${endpoints.Business.Content.BusinessLibrary(businessId)}${endpointQuery({ ...(query || {}), skip })}`, authToken, actions.business.content.api.get),
      getNonCpdContent: (authToken, businessId) => commonApiActions.authenticated.get(`${endpoints.Business.Content.NonCpd(businessId)}`, authToken, actions.business.content.api.getNonCpdContent),
      getById: (authToken, businessId, contentId) => commonApiActions.authenticated.get(`${endpoints.Business.Content.BusinessLibrary(businessId)}/${contentId}`, authToken, actions.business.content.api.getById),
      addContent: (authToken, businessId, formData) => commonApiActions.authenticated.postFormData(`${endpoints.Business.Content.BusinessLibrary(businessId)}`, authToken, formData, actions.business.content.api.addContent),
      updateContent: (authToken, businessId, formData) => commonApiActions.authenticated.putFormData(`${endpoints.Business.Content.BusinessLibrary(businessId)}/${formData.data.content.id}`, authToken, formData, actions.business.content.api.updateContent),
      archiveContent: (authToken, businessId, contentId) => commonApiActions.authenticated.put(`${endpoints.Business.Content.BusinessLibrary(businessId)}/archive/${contentId}`, authToken, {}, actions.business.content.api.archiveContent),
      loadMore: (authToken, businessId, skip, query) => commonApiActions.authenticated.get(`${endpoints.Business.Content.BusinessLibrary(businessId)}${endpointQuery({ ...(query || {}), skip })}`, authToken, actions.business.content.api.loadMore),
      deleteContent: (authToken, businessId, contentId) => commonApiActions.authenticated.delete(`${endpoints.Business.Content.BusinessLibrary(businessId)}/${contentId}`, authToken, actions.business.content.api.deleteContent),
      getContentPassedUserEmails: (authToken, businessId, contentId) => commonApiActions.authenticated.get(`${endpoints.Business.Content.BusinessLibrary(businessId)}/${contentId}/passed-user-emails`, authToken, actions.business.content.api.getContentPassedUserEmails),

      // Content Questions.
      addQuestion: (authToken, businessId, contentId, payload) => commonApiActions.authenticated.postFormData(`${endpoints.Business.Content.BusinessLibrary(businessId)}/${contentId}/questions`, authToken, payload, actions.business.content.api.addQuestion),
      updateQuestion: (authToken, businessId, contentId, questionId, payload) => commonApiActions.authenticated.putFormData(`${endpoints.Business.Content.BusinessLibrary(businessId)}/${contentId}/questions/${questionId}`, authToken, payload, actions.business.content.api.updateQuestion),
      deleteQuestion: (authToken, businessId, contentId, questionId) => commonApiActions.authenticated.delete(`${endpoints.Business.Content.BusinessLibrary(businessId)}/${contentId}/questions/${questionId}`, authToken, actions.business.content.api.deleteQuestion),
      getContentQuestions: (authToken, businessId, contentId) => commonApiActions.authenticated.get(`${endpoints.Business.Content.BusinessLibrary(businessId)}/${contentId}/questions`, authToken, actions.business.content.api.getContentQuestions)
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/business/content/actions.js